module.exports = __webpack_public_path__ + "media/images/flag_es-e0052ecf9667cc25b911d197227e2594.png";